// assets
import SchemaOutlinedIcon from '@mui/icons-material/SchemaOutlined';
import { icons } from '../master/constant';
import { getInitials } from 'utils/helpers/format.helpers';
import Avatar from 'components/ui-component/extended/Avatar';

// ==============================|| WORKFLOW MENU ITEMS ||============================== //

const workflowMenu = workflowInfo => {
	const { workflow_id: workflowId, stages, subWorkflows } = workflowInfo;

	const stagesChildren = stages.map(stage => {
		return {
			id: `stages-${stage.stage_id}`,
			title: `${stage.stage_name}`,
			type: 'item',
			url: `/workflows/${workflowId}/stages/${stage.stage_id}`,
			avatar: (
				<Avatar aria-label="stage" size="badge" sx={{ fontSize: '0.75rem' }}>
					{getInitials(stage.stage_name)}
				</Avatar>
			),
			breadcrumbs: true,
		};
	});

	const subWorkflowsChildren = subWorkflows.map(subWorkflow => {
		return {
			id: `sub-workflows-${subWorkflow.sub_workflow_id}`,
			title: `${subWorkflow.sub_workflow_name}`,
			type: 'item',
			url: `/workflows/${workflowId}/sub-workflows/${subWorkflow.sub_workflow_id}`,
			avatar: (
				<Avatar aria-label="sub_workflow" size="badge" sx={{ fontSize: '0.75rem' }}>
					{getInitials(subWorkflow.sub_workflow_name)}
				</Avatar>
			),
			breadcrumbs: true,
		};
	});

	const workflow = {
		id: 'workflow',
		name: workflowInfo.workflow_name,
		type: 'main',
		children: [
			{
				id: `${workflowId}`,
				title: 'Workflow Board',
				type: 'item',
				url: `/workflows/${workflowId}`,
				icon: SchemaOutlinedIcon,
				breadcrumbs: true,
			},
			...(stagesChildren.length > 0
				? [
						{
							id: `workflow-${workflowId}-stages`,
							title: 'Stages',
							type: 'collapse',
							icon: icons.IconStage,
							children: stagesChildren,
						},
				  ]
				: []),
			...(subWorkflowsChildren.length > 0
				? [
						{
							id: `workflow-${workflowId}-sub-workflows`,
							title: 'Sub Workflows',
							type: 'collapse',
							icon: SchemaOutlinedIcon,
							children: subWorkflowsChildren,
						},
				  ]
				: []),
			{
				id: `case-details`,
				title: 'Case Details',
				type: 'item',
				icon: icons.IconLoan,
				url: `/workflows/${workflowId}/case-details`,
			},
		],
	};

	return workflow;
};

export default workflowMenu;
